import { em } from 'polished'
import styled from 'styled-components'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  height: calc(100vh - ${p => p.theme.blocks.menuHeight});

  ${p => p.theme.mq.upMd} {
    height: calc(100vh - ${p => p.theme.blocks.menuHeightMd});
  }
`

export const SecondBlock = styled.div`
  margin-bottom: ${em(40)};
`

export const ContactsCardsWrapper = styled.div`
  ${p => p.theme.mq.upMd} {
    align-content: space-around;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    padding-bottom: ${em(40)};
  }
`

export const Slide = styled.div`
  padding-left: ${em(20)};
  padding-right: ${em(20)};
`
